import { BaseOntarioObstetricalFileSubSection, BaseOntarioObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/Ontario/Subcomponent/BaseOntarioObstetricalFileSubSection";

class BaseOntarioObstetricalFileSubLaboratorySection<TProps extends BaseOntarioObstetricalFileSubSectionProps, TState> extends BaseOntarioObstetricalFileSubSection<TProps, TState> {
    protected renderLaboratoryTextField(label: string, value: string, onChange: (value: string) => void, isRenderPositiveNegativeOption?: boolean): JSX.Element {
        return (
            <div className="col-md-6">
                {this.renderSimpleField(
                    label,
                    isRenderPositiveNegativeOption
                        ? this.controlRenderer.renderTextboxWithPositiveNegativeOption({
                            value: value,
                            onChange: value => onChange(value),
                            maxLength: 17
                        })
                        : this.controlRenderer.renderTextbox({
                            value: value,
                            onChange: value => onChange(value),
                            maxLength: 17
                        }),
                    "flex-column"
                )}
            </div>
        );
    }

    protected setBloodGroup(bloodGroup: string): void {
        this.props.mutateModelStateWithFormUpdate(s => {
            s.Opr2.InitialLabInvestigations.BloodGroup = bloodGroup;
            s.Opr2.SecondAndThirdTrimesterLab.BloodGroup = bloodGroup;
        });
    }

    protected setBloodRhesus(bloodRhesus: string): void {
        this.props.mutateModelStateWithFormUpdate(s => {
            s.Opr2.InitialLabInvestigations.BloodRhesus = bloodRhesus;
            s.Opr2.SecondAndThirdTrimesterLab.BloodRhesus = bloodRhesus;
            s.Opr3.RecommendedImmuniprophylaxis.NegativeBloodRhesus = bloodRhesus === this.controlRenderer.NEGATIVE_RHESUS;
        });
    }
}

export { BaseOntarioObstetricalFileSubLaboratorySection };
